import * as z from 'zod';

import { SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE } from 'src/features/subscriptionItemQuantityEvents/utils/types';

export type SubscriptionItemQuantityEventFormSchemaValues = z.infer<typeof subscriptionItemQuantityEventFormSchema>;
export const subscriptionItemQuantityEventFormSchema = z.object({
    recorded_at: z.string().nonempty(),
    event_type: z.enum(SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE),
    /** A delta for increment/decrement, an absolute value for set. Never negative either way. */
    quantity: z.int().min(0),
});
